module.exports = __webpack_public_path__ + "img/hr-tank-base-2.2549bd19.png";